module.exports = __webpack_public_path__ + "static/media/3.ee8c3be6.svg";